const CalendarEmptyIcon = () => {
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4.25"
        y="4.64233"
        width="32.5"
        height="32.5"
        rx="2.32143"
        stroke="#C4C4C4"
        strokeWidth="2"
      />
      <line
        x1="14.5"
        y1="2"
        x2="14.5"
        y2="7"
        stroke="#C4C4C4"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="26.5"
        y1="2"
        x2="26.5"
        y2="7"
        stroke="#C4C4C4"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line x1="4.5" y1="14" x2="37" y2="14" stroke="#C4C4C4" strokeWidth="2" />
      <path d="M15.5 20L25.5 30" stroke="#C4C4C4" strokeWidth="2" strokeLinecap="round" />
      <path d="M25.5 20L15.5 30" stroke="#C4C4C4" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default CalendarEmptyIcon;
